import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/account/admin/')({
    component: RouteComponent,
    beforeLoad: async () => {
        throw redirect({
            to: '/account/admin/$',
            params: {
                _splat: 'manage_users',
            },
        });
    },
});

function RouteComponent() {
    return <Outlet />;
}
